export default __webpack_public_path__ + "static/high-impact-51c0236560e3151a6f6c42a6bf231bef.webp";